export { Accounts as default } from "../scenes/Accounts";
